import React from 'react';
import { Button, Badge } from '@blend-ed/blendx-ui';
import PropTypes from 'prop-types';
import { formatDistance } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const ActiveTickets = ({ tickets }) => {
    const navigate = useNavigate();
    // Filter active tickets (open or escalated status)
    const activeTickets = tickets.filter(ticket =>
        ticket.status === 'Open' || ticket.status === 'Escalated'
    );

    if (activeTickets.length === 0) {
        return null;
    }

    return (
        <div className="active-tickets">
            <h2>Active Tickets</h2>
            <div className="active-tickets__container">
                {activeTickets.map((ticket) => {
                    const createdAt = new Date(ticket.createdAt);
                    const formattedCreatedAt = createdAt.toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    });

                    const timeAgo = formatDistance(
                        new Date(ticket.createdAt),
                        new Date(),
                        { addSuffix: true }
                    );

                    return (
                        <div key={ticket.id} className="active-tickets__card">
                            <div className="active-tickets__card-header">
                                <div className="active-tickets__info">
                                    <span className="active-tickets__id">#{ticket.id.substring(0, 8) || ticket.id.split('-')[0]}</span>
                                    <Badge size="md" variant={ticket.status === 'Open' ? 'success' : 'orange'}>
                                        {ticket.status === 'Open' ? 'In Progress' : ticket.status.charAt(0).toUpperCase() + ticket.status.slice(1)}
                                    </Badge>
                                </div>
                                <Button
                                    variant="outline-gray"
                                    size="xs"
                                    className="active-tickets__view-btn"
                                    onClick={() => navigate(`/support/view-ticket/${ticket.id}`)}
                                >
                                    View Ticket
                                </Button>
                            </div>
                            <h3 className="active-tickets__title">{ticket.title}</h3>
                            <p className="active-tickets__description">{ticket.description}</p>
                            <div className="active-tickets__meta">
                                <span>Created: {formattedCreatedAt}</span>
                                <span>Last Update: {timeAgo}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

ActiveTickets.propTypes = {
    tickets: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            status: PropTypes.string.isRequired,
            createdAt: PropTypes.string.isRequired,
        })
    ).isRequired,
    onViewTicket: PropTypes.func,
};

export default ActiveTickets; 